<template>
	<div class="bg-[#F6F8FA]">
		<Header :current="0"></Header>
		<div class="2xl:max-w-7xl xl:max-w-7xl mx-auto mb-[100px]">
			<div class="banner mb-[20px]">
				<el-carousel height="263px" class="" style="width:100%;" arrow="always" :autoplay="false">
					<el-carousel-item v-for="(item,index) in bannerList" :key="index">
						<el-image class="w-full h-full" :src="item.image" fit="cover"></el-image>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="bg-white mb-[20px] py-[20px] px-[60px] box-border flex flex-wrap">
				<div @click="selectNav(0)" :class="navValue==0?'text-white bg-[#2979FF] rounded-[50px]':''"
					class="leading-[23px] cursor-pointer text-[14px] mr-[10px] px-[12px]">
					{{langInfo.class_all}}
				</div>
				<div @click="selectNav(item.id)" :class="navValue==item.id?'text-white bg-[#2979FF] rounded-[50px]':''"
					class="leading-[23px] cursor-pointer text-[14px] mr-[10px] px-[12px]"
					v-for="(item,index) in navList" :key="index">
					{{item.title}}
				</div>
			</div>
			<div class=" bg-white py-[20px] box-border pb-[80px] px-[57px]">
				<div v-if="resourceList.length>0&&isFinish" class="  py-[20px] box-border pb-[80px] px-[57px]">
					<div class=" mb-[105px]">
						<router-link :to="{path:'/resourceDetail',query: { id: item.id }}"
							class="cursor-pointer no-underline bB-01 flex items-center justify-between newsItem py-5  box-border "
							v-for="(item,index) in resourceList" :key="index">
							<el-image class="w-[211.5px] h-[90px] mr-[10px]" :src="item.image" fit="cover"></el-image>
							<div class="h-[106px] pt-[4px] box-border" style="width: calc(100% - 180px);">
								<div class="mb-[20px]">
									<p class="text-[16px] text-[#101010] font-bold  mb-2.5 yw-text-cut-1" style="">
										{{item.title}}
									</p>
									<div class="text-[14px] text-[#A6A6A6] yw-text-cut-1">
										{{item.subtitle}}
									</div>
								</div>
								<div
									class="text-[#686C73] cursor-pointer  box-border flex   items-center justify-between">
									<label class="flex items-center cursor-pointer text-[14px]"><img
											src="@/static/image/icon58.png" class="w-[20px] h-[20px]" alt=""
											srcset="" /> {{item.create_time}}</label>
									<div class="flex   items-center">
										<img src="@/static/image/icon04.png" class="w-[22px] h-[22px] mr-2" alt="" />
										<label class="mr-[15px] text-[#101010]">{{item.number_views}}</label>
										<img src="@/static/image/icon05.png" class="w-[22px] h-[22px] mr-2" alt="" />
										<label class="text-[#101010]">{{item.number_likes}}</label>
									</div>
								</div>
							</div>
						</router-link>
					</div>
					<div class="flex justify-center">
						<el-pagination :page-size="pageSize" :total="total" :current-page="currentPage"
							@current-change="currentChange" background layout="prev, pager, next">
						</el-pagination>
					</div>
				</div>
				<emptyPage v-else-if="isFinish&&resourceList.length==0" :title="langInfo.no_data_available">
				</emptyPage>
			</div>


		</div>

		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header.vue'
	import Footer from '@/components/Footer.vue'
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			Header,
			Footer,
			emptyPage
		},
		data() {
			return {
				bannerList: [],
				navValue: 0,
				navList: [],
				pageSize: 8, //每页显示条目个数
				total: 0,
				currentPage: 1,
				isFinish: false,
				resourceList: [],
				langInfo: {},
			}
		},
		mounted() {
			this.get_resource_classify()
			this.resource_download_list()

			this.get_banner_list()
			this.getdict_data()

		},
		methods: {
			get_banner_list() {
				this.$api.bannerList({
					mark: 'resource_download'
				}).then((res) => {
					console.log(res);
					this.bannerList = res.data.list_class
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					document.title =this.langInfo.pc_name+'-'+ this.langInfo.head_download_nav


				}).catch((error) => {})
			},
			// 选择分类
			selectNav(type) {
				this.navValue = type
				this.isFinish = false
				this.currentPage = 1
				this.resourceList = []
				this.resource_download_list()
			},
			currentChange(e) {
				console.log(e);
				this.currentPage = e

				this.isFinish = false
				this.resourceList = []
				this.resource_download_list()

			},
			get_resource_classify() {
				this.$api.resource_classify({}).then((res) => {
					console.log("资源分类=====");
					console.log(res);
					this.navList = res.data
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			resource_download_list() {
				// 资讯列表
				this.$api.resource_download_list({
					page: this.currentPage,
					limit: this.pageSize,
					resource_classify_id: this.navValue > 0 ? this.navValue : ''
				}).then((res) => {
					
					this.resourceList = res.data.list
					this.isFinish = true
					this.total = res.data.total
				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
		}
	}
</script>

<style scoped>
	.banner {
		height: 263px;
		background: linear-gradient(180deg, rgba(110, 175, 247, 1) 0%, rgba(112, 176, 247, 0.64) 0%, rgba(120, 179, 248, 0.11) 34%, rgba(255, 255, 255, 0.11) 100%);
	}
</style>